module.exports = __webpack_public_path__ + "assets/img/1s.3a3ecb5e.png";